import React, { useState } from "react";
import { useInView } from "react-intersection-observer";

const faqs = [
  {
    q: "Is Zero Typing available for macOS?",
    a: "Yes. Zero Typing is designed to help you dictate and write naturally across your Mac apps.",
  },
  {
    q: "How do I install it on my Mac?",
    a: "Download the .dmg, open it, and drag Zero Typing into your Applications folder. Launch it and you're ready to speak.",
  },
  {
    q: "Which Mac apps are supported?",
    a: "Zero Typing works across Apple Mail, Notes, Safari, Word, Chrome, Slack, Notion, and any app with a text field on your Mac.",
  },
  {
    q: "Does Zero Typing need microphone access?",
    a: "Yes. macOS will ask for microphone permission the first time you use voice typing.",
  },
  {
    q: "Can I use Zero Typing with my MacBook?",
    a: "Absolutely. Zero Typing runs natively on Apple Silicon and Intel Macs, including MacBook, iMac, and Mac mini.",
  },
  {
    q: "Can I cancel whenever I want?",
    a: "Absolutely. Cancel anytime from your account settings. No questions asked.",
  },
  {
    q: "What if I get stuck during installation?",
    a: "Reach out via the Help page, and our team responds within a few hours during business days.",
  },
];

const FAQItem = ({ q, a, open, onToggle, animate, delay }) => (
  <div
    style={{ animationDelay: `${delay}ms` }}
    className={`${animate ? "animate-slideUp z-[3] anim-preserve" : "opacity-0 z-0"
      } rounded-2xl border border-[#0000000D] transition-all ${open ? "bg-[#F3F8FD]" : "bg-[#F9F9F9]"
      }`}
  >
    <button
      onClick={onToggle}
      className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left"
    >
      <span className="font-inter font-semibold text-[#0F1B2D] text-[0.95rem] sm:text-[1rem] leading-[1.45]">
        {q}
      </span>
      <span className="text-[#33425A] text-xl font-light shrink-0 leading-[1.45]">
        {open ? "×" : "+"}
      </span>
    </button>
    {open && (
      <div className="px-5 pb-4 font-inter text-[#33425A] text-[0.875rem] sm:text-[0.9375rem] leading-[1.55]">
        {a}
      </div>
    )}
  </div>
);

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(-1);
  const { ref: headRef, inView: headView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const { ref: listRef, inView: listView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="w-full max-w-[820px] mx-auto md:px-7 px-4 flex flex-col gap-8">
      <h2
        ref={headRef}
        className={`${headView ? "animate-slideUp z-[3] anim-preserve" : "opacity-0 z-0"
          } font-jakarta font-extrabold text-[#0F1B2D] text-center text-[2.625rem] md:text-[2.4rem] lg:text-[2.8rem] xl:text-[3.125rem] leading-[1.24] tracking-[-0.02em]`}
      >
        Questions,{" "}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
          Answered.
        </span>
      </h2>

      <div ref={listRef} className="flex flex-col gap-3">
        {faqs.map((f, i) => (
          <FAQItem
            key={i}
            q={f.q}
            a={f.a}
            open={openIdx === i}
            onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            animate={listView}
            delay={i * 100}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
